import React, { FC } from 'react';
import cn from 'classnames';
import { IconItemType } from '../../Buttons/types';
import { getDefaultIconValues } from '../../Buttons/helpers';
import { TAGS } from '../classnames';
import { StateTagProps } from './types';
import Text from '../../Text';

const StateTag: FC<StateTagProps> = ({
  type = 'green',
  label,
  className = '',
  as,
  href,
  onClick,
  cursor: cursorProp,
  leftIcon: leftIconProp,
  darkMode,
  ...other
}) => {
  const HTMLTag: keyof JSX.IntrinsicElements | React.ComponentType<any> =
    as || 'div';
  const leftIcon: IconItemType = getDefaultIconValues(leftIconProp, 16);
  const props = { href, onClick, ...other };
  const cursor = cursorProp || (href || onClick ? 'pointer' : 'default');

  return (
    <HTMLTag
      className={cn(TAGS.state[type], `cursor-${cursor}`, className)}
      {...props}
    >
      {leftIcon.component && (
        <leftIcon.component
          size={leftIcon.size}
          className={cn(
            {
              'fill-current': leftIcon.hasFill,
              'stroke-current': leftIcon.hasStroke,
            },
            'flex-shrink-0 mr-4',
          )}
          ignoreColor
        />
      )}
      <Text type="caption" color="inherit">
        {label}
      </Text>
    </HTMLTag>
  );
};

export default StateTag;
